// extracted by mini-css-extract-plugin
export var actions = "_ud-4";
export var item = "_ud-1";
export var price = "_ud-3";
export var quantity = "_ud-2";
export var table = "_ud-0";